import i18n from "i18next"
import Backend from "i18next-http-backend"
import LanguageDetector from "i18next-browser-languagedetector"
import { initReactI18next } from "react-i18next"
import translationEN from "./locales/EN/translation.json"
import translationLV from "./locales/LV/translation.json"

const DETECTION_OPTIONS = {
	order: ["querySelection", "cookie"],
	cache: ["cookie"],
}
const resources = {
	en: {
		translation: translationEN,
	},
	lv: {
		translation: translationLV,
	},
}
i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		lng: "lv",
		resources,
		detection: DETECTION_OPTIONS,
		fallbackLng: "en",
		// debug: true,
		interpolation: {
			escapeValue: false,
		},
	})

export default i18n
